// Andy 5-16-22 as of now these are the only RulesKey associated with
// custom HPL finishes being sent to SAP.
const HPL_FINISH_TYPES = {
  doorFinish: "C3CUDoorFinishId",
  woodFinish: "FinishId"
};

// These are the keys that SAP is expecting for custom finishes
const SAP_AMATNR_CODES = {
  doorFinish: "C3K_DOOR_COLOR_CUS",
  woodFinish: "FRN_COLOR_CUSTOM",
  Material: "FRN_MFG_CUSTOM",
  doorMaterial: "C3K_DOOR_MFG_CUS"
};

function getcustomHPLFormItems(matwa, customFormData) {
  return customFormData.reduce((accArray, item) => {
    const { ColorName, ColorNumber, Manufacturer } = item;
    var adescription;
    var manufacturerDescription;
    if (Manufacturer != null) {
      adescription = `${ColorNumber} ${ColorName}`.toUpperCase();
      manufacturerDescription = `${Manufacturer}`.toUpperCase();
    } else {
      adescription = `${ColorNumber} ${ColorName}`.toUpperCase();
    }

    const atypeForCustomColor = ";";
    var customHPLObj;

    if (Manufacturer != null) {
      customHPLObj = {
        matwa,
        aquantity: 1,
        aposition: null,
        adescription,
        atype: atypeForCustomColor
      };
      var customHPLManufacturerObj = {
        matwa,
        aquantity: 1,
        aposition: null,
        adescription: manufacturerDescription,
        atype: atypeForCustomColor
      };
    } else {
      customHPLObj = {
        matwa,
        aquantity: 1,
        aposition: null,
        adescription,
        atype: atypeForCustomColor
      };
    }

    if (item.RulesKey === HPL_FINISH_TYPES.doorFinish) {
      if (Manufacturer != null) {
        accArray.push({
          ...customHPLObj,
          amatnr: SAP_AMATNR_CODES.doorFinish
        });
        accArray.push({
          ...customHPLManufacturerObj,
          amatnr: SAP_AMATNR_CODES.doorMaterial
        });
      } else {
        accArray.push({
          ...customHPLObj,
          amatnr: SAP_AMATNR_CODES.doorFinish
        });
      }
    }

    if (item.RulesKey === HPL_FINISH_TYPES.woodFinish) {
      if (Manufacturer != null) {
        accArray.push({
          ...customHPLObj,
          amatnr: SAP_AMATNR_CODES.woodFinish
        });
        accArray.push({
          ...customHPLManufacturerObj,
          amatnr: SAP_AMATNR_CODES.Material
        });
      } else {
        accArray.push({
          ...customHPLObj,
          amatnr: SAP_AMATNR_CODES.woodFinish
        });
      }
    }

    return accArray;
  }, []);
}

export default {
  getcustomHPLFormItems
};
